<a href="tel:30030256" title="Ligar para mais informações">
  <i class="icon-phone-sound"></i>
  <span>3003-0256</span>
</a>